import {CampaignTestModel} from "../../common/models/Campaign";
import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {CommandResult} from "../../common/helpers/CommandResult";

export const testCampaign = (campaign: CampaignTestModel): Promise<CommandResult> => {
    return AxiosClientFactory
        .getInstance()
        .post(`/api/campaigns/test`, campaign)
        .then((result) => new CommandResult(result));
};